import FW from '../fw/fw';


export default class DvrManagement {

  #rmp;
  #resyncDvrCurrentTime = 0;
  #resyncPauseTime = 0;
  #dvrSetLiveModeFn = null;
  #playingDvrFn = null;
  #pauseDvrFn = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get resyncPauseTime() {
    return this.#resyncPauseTime;
  }

  set resyncPauseTime(value) {
    this.#resyncPauseTime = value;
  }

  get resyncDvrCurrentTime() {
    return this.#resyncDvrCurrentTime;
  }

  set resyncDvrCurrentTime(value) {
    this.#resyncDvrCurrentTime = value;
  }

  #playingDvr() {
    this.#rmp.off('timeupdate', this.#playingDvrFn);
    if (this.#rmp.rmpHlsJS) {
      let slide = FW.getMediaDuration(this.#rmp.dom.video) - this.#rmp.rmpHlsJS.hlsJSLevelDuration;
      if (FW.isFiniteNumber(slide) && FW.isFiniteNumber(this.#resyncDvrCurrentTime) && this.#resyncDvrCurrentTime > 0) {
        this.#rmp.dvrSeekTo((this.#resyncDvrCurrentTime - slide) * 1000).catch(error => {
          this.#rmp.rmpUtils.warning(1018, error);
        });
      }
    } else if (this.#rmp.readingShaka) {
      const seekRange = this.#rmp.shakaPlayer.seekRange();
      const end = seekRange.end;
      const start = seekRange.start;
      this.#resyncPauseTime = (FW.getNow() - this.#resyncPauseTime) / 1000;
      if (FW.isFiniteNumber(end) && end > 0) {
        this.#rmp.dvrSeekTo((end - start - this.#resyncPauseTime) * 1000).catch(error => {
          this.#rmp.rmpUtils.warning(1018, error);
        });
      }
    }
    this.#resyncPauseTime = 0;
    this.#resyncDvrCurrentTime = 0;
    this.#rmp.on('pause', this.#pauseDvrFn);
  }

  #pauseDvr() {
    if (this.#rmp.isDvrLiveMode) {
      this.#rmp.off('pause', this.#pauseDvrFn);
      if (this.#rmp.readingHlsJS) {
        this.#resyncDvrCurrentTime = FW.getMediaCurrentTime(this.#rmp.dom.video);
      } else if (this.#rmp.readingShaka) {
        this.#resyncPauseTime = FW.getNow();
      }
      this.#rmp.on('timeupdate', this.#playingDvrFn);
    }
  }

  #setLiveModeUI() {
    this.#rmp.isDvrLiveMode = true;
    this.#rmp.dom.container.classList.replace('rmp-dvr-vod', 'rmp-dvr-live');
    this.#rmp.dom.current.style.width = '100%';
    this.#rmp.dom.handle.style.left = '100%';
    this.#rmp.dispatch('dvrislive');
  }

  setLiveMode(event) {
    FW.eventStopPrevent(event);
    // if already in live mode we return
    if (this.#rmp.isDvrLiveMode) {
      return;
    }
    // seek to edge
    if (this.#rmp.rmpHlsJS) {
      this.#rmp.rmpHlsJS.syncHlsJSToLiveEdge();
    } else if (this.#rmp.shakaPlayer) {
      this.#rmp.shakaPlayer.goToLive();
    }
    // set live UI
    this.#setLiveModeUI();
  }

  wirePauseDvrEvents() {
    this.#rmp.on('pause', this.#pauseDvrFn);
  }

  unwireDvrEvents() {
    this.#rmp.off('pause', this.#pauseDvrFn);
    this.#rmp.off('timeupdate', this.#playingDvrFn);
  }

  destroy() {
    this.unwireDvrEvents();
    FW.removeEvents(['touchend', 'click'], this.#rmp.dom.time, this.#dvrSetLiveModeFn);
  }

  appendDvrUI() {
    if (this.#rmp.isDvr) {
      return;
    }
    this.#rmp.isDvr = true;
    this.#rmp.isVod = false;
    this.#rmp.detectLive = false;
    this.#rmp.adTagReloadOnEnded = false;
    this.#rmp.rmpSeekManagement.appendSeekBar();
    FW.setText(this.#rmp.dom.timeElapsedText, this.#rmp.labels.hint.live);
    this.#rmp.dom.container.classList.add('rmp-dvr', 'rmp-dvr-live');

    this.#dvrSetLiveModeFn = this.setLiveMode.bind(this);
    FW.addEvents(['touchend', 'click'], this.#rmp.dom.time, this.#dvrSetLiveModeFn);

    this.#pauseDvrFn = this.#pauseDvr.bind(this);
    this.#playingDvrFn = this.#playingDvr.bind(this);
    this.#rmp.on('pause', this.#pauseDvrFn);
    this.#setLiveModeUI();
  }

}
